<template>
  <div class="report">
    <Form>
      <Row class="filter-row">
        <iCol
          class="filter-item"
          span="6"
        >
          <DatePicker
            class="time-range-filter"
            :value="[beginTime, endTime]"
            type="daterange"
            size="large"
            format="yyyy年MM月dd日"
            :editable="false"
            :clearable="false"
            @on-change="timeRangeChanged"
          />
        </iCol>
        <iCol
          class="filter-item"
          span="6"
        >
          <Select
            :value="mediaId"
            size="large"
            clearable
            transfer
            placeholder="媒体选项"
            @on-change="mediaChanged"
          >
            <Option
              v-for="(media, index) in allMedia"
              :key="index"
              :value="media.id"
              :label="media.media_name"
            />
          </Select>
        </iCol>
        <iCol
          class="filter-item"
          span="6"
        >
          <Select
            :value="adspotId"
            size="large"
            clearable
            transfer
            placeholder="广告位选项"
            @on-change="adspotChanged"
          >
            <Option
              v-for="(adspot, index) in allAdspot"
              :key="index"
              :value="adspot.id"
              :label="adspot.adspot_name"
            />
          </Select>
        </iCol>
        <iCol
          class="filter-item"
          span="6"
        >
          <Select
            :value="supplierId"
            size="large"
            clearable
            transfer
            placeholder="渠道选项"
            @on-change="supplierChanged"
          >
            <Option
              v-for="(supplier, index) in allSupplier"
              :key="index"
              :value="supplier.id"
              :label="supplier.supplier_name"
            />
          </Select>
        </iCol>
      </Row>
    </Form>
    <Table
      class="summary-table"
      :columns="summaryColumns"
      :data="[reportSummary]"
      size="large"
    />
    <Table
      :columns="columns"
      :data="reportDetail"
      stripe
    />
  </div>
</template>

<script>
import { Row, Col, Form, Select, Option, Table, DatePicker } from 'iview'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import moment from 'moment'

export default {
  components: {
    Row,
    iCol: Col,
    Form,
    Select,
    Option,
    Table,
    DatePicker
  },

  data () {
    const percentage = prop => (create, data) => create(
      'span',
      `${data.row[prop] === null ? 0 : (data.row[prop] * 100).toFixed(2) / 1} %`
    )

    return {
      summaryColumns: [
        {
          title: ' ',
          key: 'meaning',
          width: 70,
          render: (create, data) => create(
            'span',
            {
              style: {
                fontWeight: 600
              }
            },
            '总数'
          )
        },

        { title: '请求广告数', key: 'requests', align: 'center' },
        { title: '广告竞价数', key: 'succeeds', align: 'center' },
        {
          title: '竞价率',
          key: 'bid_rate',
          align: 'center',
          render: percentage('bid_rate')
        }
      ],

      columns: [
        {
          title: '时间',
          key: 'timestamp',
          render: (create, data) => create(
            'span',
            this.beginTime === moment().format('YYYY-MM-DD') ?
              moment.unix(data.row.timestamp).format('YYYY年MM月DD日 HH时') :
              moment.unix(data.row.timestamp).format('YYYY年MM月DD日')
          )
        },

        { title: '媒体', key: 'media_name' },
        { title: '广告位', key: 'adspot_name' },
        { title: '渠道', key: 'supplier_name' },
        { title: '请求广告数', key: 'requests', align: 'center' },
        { title: '广告竞价数', key: 'succeeds', align: 'center' },
        {
          title: '竞价率',
          key: 'bid_rate',
          align: 'center',
          render: percentage('bid_rate')
        }
      ]
    }
  },

  computed: {
    ...mapState('media', {
      allMedia: 'mediaList'
    }),
    ...mapState('adspot', {
      allAdspot: 'adspotList'
    }),
    ...mapState('supplier', {
      allSupplier: 'supplierList'
    }),

    ...mapState('dashboard', [
      'mediaId',
      'adspotId',
      'supplierId',
      'isHour',
      'reportSummary',
      'reportDetail'
    ]),

    ...mapGetters('dashboard', [
      'beginTime',
      'endTime'
    ])
  },

  created () {
    this.getReport()
    this.getAllMedia()
    this.getAllAdspot()
    this.getAllSupplier()
  },

  methods: {
    ...mapActions('media', {
      getAllMedia: 'getAll'
    }),
    ...mapActions('adspot', {
      getAllAdspot: 'getAll'
    }),
    ...mapActions('supplier', {
      getAllSupplier: 'getAll'
    }),

    ...mapActions('dashboard', [
      'getReport'
    ]),
    ...mapMutations('dashboard', [
      'changeTimeRange',
      'changeMedia',
      'changeAdspot',
      'changeSupplier',
      'changeIsHour'
    ]),

    timeRangeChanged ([beginTime, endTime]) {
      this.changeTimeRange({
        beginTime,
        endTime
      })
      this.getReport()
    },

    mediaChanged (mediaId) {
      this.changeMedia({ mediaId })
      this.getReport()
    },

    adspotChanged (adspotId) {
      this.changeAdspot({ adspotId })
      this.getReport()
    },

    supplierChanged (supplierId) {
      this.changeSupplier({ supplierId })
      this.getReport()
    },

    isHourChanged (isHour) {
      this.changeIsHour({ isHour })
      this.getReport()
    }
  }
}
</script>

<style lang="less" scoped>
.filter-row {
  margin: 0 -10px 20px;
}
.filter-item {
  padding: 0 10px;
}
.time-range-filter {
  width: 100%;
}
.summary-table {
  margin-bottom: 20px;
}

</style>
